<div
  class="image-prompt"
  (click)="$event.stopPropagation()"
  *ngIf="imagePrompt$ | async as imagePrompt"
>
  <div class="p-12">
    <textarea
      #prompt
      placeholder="Enter image prompt"
      (keyup)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      [value]="imagePrompt.prompt"
      (keyup.enter)="enter($event)"
      (change)="updateText($event)"
    ></textarea>
    <div class="flex-row justify-end row">
      <div class="arrow-border" (click)="generateImage(imagePrompt.prompt)">
        <nw-icon type="arrow_upward"></nw-icon>
      </div>
    </div>

    <ng-container *ngIf="imagePrompt.isLoading">
      <div
        *ngIf="imagePrompt.isLoading"
        class="flex-row space-around"
        style="
          width: 300px;
          height: 300px;
          border: 1px solid white;
          margin: 10px auto;
          border-radius: 12px;
        "
      >
        <div class="blink">
          <nw-icon type="imagesmode" [outlined]="true" [size]="20"></nw-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="imagePrompt.imageIRI && !imagePrompt.isLoading">
      <div style="margin: 10px auto">
        <img
          *ngIf="imagePrompt.imageIRI && !imagePrompt.isLoading"
          [src]="imagePrompt.imageIRI"
          style="
            width: 420px;
            height: 420px;
            border: 1px solid white;
            border-radius: 12px;
          "
        />
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="imagePrompt.imageIRI && !imagePrompt.isLoading"
    class="flex-row space-around"
    style="border-top: 1.25px solid white"
  >
    <div
      class="submit-icon-container"
      (mouseenter)="hoverButton('discard')"
      (mouseleave)="unhoverButton()"
      (click)="discard()"
    >
      <nw-icon
        type="close"
        [size]="hoveredButton === 'discard' ? 17 : 14"
      ></nw-icon>
      <!-- [color]="hoveredButton === 'discard' ? '#072037' : 'white'" -->
    </div>
    <div
      class="submit-icon-container"
      (mouseenter)="hoverButton('add')"
      (mouseleave)="unhoverButton()"
      (click)="addImage()"
    >
      <nw-icon
        type="check"
        [size]="hoveredButton === 'add' ? 17 : 14"
      ></nw-icon>
      <!-- [color]="hoveredButton === 'add' ? '#072037' : 'white'" -->
    </div>
  </div>
</div>
